module.exports = __webpack_public_path__ + "static/media/1.4b2b35a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80423/1.jpg
// module id = 805
// module chunks = 0